'use strict';

var _ = require('lodash');
var SaveNotificationModalController = function SaveNotificationModalController($scope, $rootScope, scenarioService, $timeout) {
  var changedValue = [];
  function modeLabel() {
    return !scenarioService.isScenarioSelected() ? 'production' : 'scenario';
  }
  $scope.updateMessage = function () {
    $scope.modalMessage = 'Would you like to save your changes to ' + modeLabel() + '?';
  };
  $scope.$on('grid:cellValueChanged', function (event, rowInfo, gridId) {
    if (!_.find(changedValue, {
      datafield: rowInfo.datafield,
      rowindex: rowInfo.rowindex,
      grid: gridId
    })) {
      changedValue.push({
        datafield: rowInfo.datafield,
        rowindex: rowInfo.rowindex,
        grid: gridId,
        old: rowInfo.oldvalue,
        "new": rowInfo.newvalue
      });
    } else {
      var sameValue = _.find(changedValue, {
        datafield: rowInfo.datafield,
        rowindex: rowInfo.rowindex,
        grid: gridId
      });
      if (rowInfo.newvalue === sameValue.old || rowInfo.newvalue === '' || rowInfo.newvalue === '' && !sameValue.old) {
        _.remove(changedValue, _.find(changedValue, {
          datafield: rowInfo.datafield,
          rowindex: rowInfo.rowindex,
          grid: gridId
        }));
      }
    }
    if (_.isNil(rowInfo.newvalue) && rowInfo.oldvalue === '') {
      _.remove(changedValue, _.find(changedValue, {
        datafield: rowInfo.datafield,
        rowindex: rowInfo.rowindex,
        grid: gridId,
        "new": rowInfo.newvalue,
        old: rowInfo.oldvalue
      }));
    }
    $rootScope.$broadcast('getChangedValue', changedValue);
  });
  $scope.isDirty = function () {
    return !!changedValue.length;
  };
  $scope.sendRouterStateEvent = function () {
    if ($scope.nextState) {
      $rootScope.$broadcast('$stateChangeStart', $scope.nextState);
      delete $scope.nextState;
    }
  };
  $scope.invokeCallback = function (callback) {
    if (callback) {
      callback();
    }
  };
  $scope.onNoBtnClick = function () {
    if ($scope.callbacks) {
      $scope.invokeCallback($scope.callbacks.onNoBtnClick);
      delete $scope.callbacks;
    }
  };
  $scope.onGridPristine = function () {
    if ($scope.callbacks) {
      $scope.invokeCallback($scope.callbacks.onGridPristine);
      delete $scope.callbacks;
    }
  };
  $scope.$on('clearChangedValue', function () {
    $rootScope.$broadcast('getChangedValue', []);
  });
  $scope.cancelStateChange = function () {
    $rootScope.$broadcast('$stateChangeCancel');
  };
  $scope.noAndContinue = function () {
    $scope.hideSaveModal();
    $rootScope.$broadcast('getChangedValue', []);
    $scope.sendRouterStateEvent();
    $scope.onNoBtnClick();
  };
  $scope.saveAndContinue = function () {
    var currentState = _.replace($scope.fromState, 'app.', '');
    if ($scope.postDeparture) {
      $rootScope.$broadcast('save-modal:flight-analysis-post-departure-recordChanges');
    } else {
      $rootScope.$broadcast('save-modal:' + currentState + '-recordChanges');
    }
    $scope.hideSaveModal();
    $rootScope.$broadcast('getChangedValue', []);
    $scope.sendRouterStateEvent();
  };
  $scope.$on('grid:data-pristine', function () {
    // below ugly hack was introduced because
    // OverrideUtilService#cleanUpOverrides calls indirectly
    // $scope.asyncGridApply('setcellvaluebyid', ...) with timeout(0)
    //
    // It causes 'grid:cellValueChanged' grid event is always sent in the end of cleaning process
    // what makes grid dirty again

    $timeout(function () {
      changedValue = [];
      $rootScope.$broadcast('getChangedValue', []);
    }, 10);
    $scope.onGridPristine();
  });
};
SaveNotificationModalController.$inject = ['$scope', '$rootScope', 'ScenarioService', '$timeout'];
module.exports = SaveNotificationModalController;